import { render, staticRenderFns } from "./tab_kol_entity.vue?vue&type=template&id=23f05c2e&scoped=true&"
import script from "./tab_kol_entity.vue?vue&type=script&lang=js&"
export * from "./tab_kol_entity.vue?vue&type=script&lang=js&"
import style0 from "./tab_kol_entity.vue?vue&type=style&index=0&id=23f05c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f05c2e",
  null
  
)

export default component.exports